import request from "./httpService";

const LENS_PRICING_ENDPOINT = '/validdata/lenspricingmatrix';

/**
 * Get all pricing matrix combos for a manufacturer
 * Used in lens configuration grid to display all available combinations upfront
 * @param {number} manufacturerId - The manufacturer ID
 * @returns {Promise} Array of pricing combos with model, material, index, costs, and treatment count
 */
const getPricingByManufacturer = (manufacturerId) => {
    return request({
        method: "GET",
        url: `${LENS_PRICING_ENDPOINT}/by-manufacturer`,
        params: { manufacturerId }
    });
};

/**
 * Get pricing for a specific lens configuration
 * Calculates total cost/retail including treatments
 * @param {object} config - Configuration with { lensModelId, lensMaterialId, lensIndexId, treatmentIds }
 * @returns {Promise} Pricing object with base costs, total costs, and available treatments
 */
const getPricing = (config) => {
    return request({
        method: "POST",
        url: `${LENS_PRICING_ENDPOINT}/getpricing`,
        data: config
    });
};

/**
 * Get available material/index options for a model
 * @param {number} lensModelId - The lens model ID
 * @param {number|null} lensMaterialId - Optional material ID to get indexes for
 * @returns {Promise} Object with { materials: [] } or { indexes: [] }
 */
const getAvailableOptions = (lensModelId, lensMaterialId) => {
    return request({
        method: "GET",
        url: `${LENS_PRICING_ENDPOINT}/available-options`,
        params: { lensModelId, lensMaterialId }
    });
};

export const LensConfigurationService = {
    getPricingByManufacturer,
    getPricing,
    getAvailableOptions
};

export default LensConfigurationService;
